// We're using mstage userkit as a tool for composing and sending tracking trigger events to our event-tracking-service
const tracker = require('./mstage-user-kit')(window || {});

const globalProperties = require('./global-properties')
const impression = require('./impression')
const { clickProperties } = require('../events/click')
const { pageviewProperties } = require('../events/pageview')
const { customizedEventProperties } = require('../events/customized')
const checkingChannel = require('./checking-channel')

impression.init(tracker);
tracker.registerImpression = function(evtName = 'Web.Impression.Content', properties) {
  impression.register(evtName, impressionProperties(properties, globalProperties()), tracker);
}

tracker.global = function showGlobalConfig() {
}

tracker.click = function click(properties, evtName = 'click.body', callback) {
  tracker.track(evtName, clickProperties(properties, globalProperties()), callback)
}

tracker.pageview = function pageview(properties, evtName = 'Web.View.Screen') {
  tracker.track(evtName, pageviewProperties(properties, globalProperties()))
}

tracker.event = function customEvent(properties, evtName, callback) {
  if (!evtName) {
    console.error('Event name is mandatory in trigger event method!!')
    return;
  }
  tracker.track(evtName, customizedEventProperties(properties, globalProperties()), callback)
}

// execute eventTrackerAsyncInit function from browser
function executeAsyncInit () {
  window && window.eventTrackerAsyncInit && window.eventTrackerAsyncInit(tracker)
  checkingChannel.runTracker(tracker);
  checkingChannel.exposeTracker(tracker, window);
}

executeAsyncInit()

module.exports = tracker;